import { render, staticRenderFns } from "./ImportedActivityStatsSectionPlaceholder.vue?vue&type=template&id=157ee8eb&scoped=true&"
import script from "./ImportedActivityStatsSectionPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ImportedActivityStatsSectionPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ImportedActivityStatsSectionPlaceholder.vue?vue&type=style&index=0&id=157ee8eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157ee8eb",
  null
  
)

export default component.exports